<!-- Responsibility: Implement account menu behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<account-menu>
  <div class="profile-menu-container" if={ isSignedIn() }>
    <button id="profile-btn" class="profile-btn tooltip-wrap" aria-label="Open account menu" onclick={ toggleMenu }>
      <span id="profile-btn-inner" each={ _ in [1] }>
        <img if={ props.view?.photoURL } src={ props.view.photoURL } class="profile-btn-avatar" alt="avatar">
        <span if={ !props.view?.photoURL } class="profile-btn-initials">{ props.view?.initials }</span>
      </span>
      <div class="tooltip" data-position="bottom">Account Settings</div>
    </button>
    <div id="profile-dropdown" class="profile-dropdown" hidden={ !props.view?.profileOpen } onclick={ handleMenuClick }>
      <header>
        <strong>{ props.view?.displayName }</strong>
        <span>{ props.view?.email }</span>
      </header>
      <div role="separator" aria-hidden="true"></div>
      <button if={ props.view?.isAdmin } data-action="admin-dashboard">ADMIN DASHBOARD</button>
      <button if={ props.view?.isAdmin } data-action="welcome-page">WELCOME PAGE</button>
      <button if={ props.view?.isAdmin } data-action="system-controls">SYSTEM CONTROLS</button>
      <button if={ props.view?.isAdmin && props.view?.isDev } data-action="dev-observability">DEV OBSERVABILITY</button>
      <button data-action="settings">AI SETTINGS</button>
      <button data-action="about">ABOUT GAME</button>
      <button if={ props.view?.isAdmin && props.view?.pwaInstallReady } data-action="install-pwa">INSTALL APP</button>
      <button if={ props.view?.isAdmin && props.view?.pwaUpdateReady } data-action="apply-pwa-update">APPLY UPDATE</button>
      <button if={ props.view?.isAdmin } data-action="switch-account">SWITCH ACCOUNT</button>
      <div role="separator" aria-hidden="true"></div>
      <button class="danger" data-action="sign-out">SIGN OUT</button>
    </div>
  </div>
  <button if={ !isSignedIn() } class="sbar-signin-btn" onclick={ () => props.actions?.switchAccount?.() } aria-label="Sign in">SIGN IN</button>

  <script>
    export default {
      isSignedIn() {
        return !!(this.props.view?.displayName || this.props.view?.photoURL)
      },

      toggleMenu() {
        this.props.actions?.toggleProfileDropdown?.()
      },

      handleMenuClick(e) {
        const btn = e.target.closest('button[data-action]')
        if (!btn) return
        const action = btn.dataset.action
        const actions = {
          'admin-dashboard': 'openAdminDashboardPage',
          'welcome-page': 'openWelcomePage',
          'system-controls': 'openSystemControlsModal',
          'dev-observability': 'openDevObservabilityPage',
          'settings': 'openSettingsModal',
          'about': 'openAboutModal',
          'install-pwa': 'installPwa',
          'apply-pwa-update': 'applyPwaUpdateNow',
          'switch-account': 'switchAccount',
          'sign-out': 'signOut',
        }
        const methodName = actions[action]
        if (methodName) this.props.actions?.[methodName]?.()
      },

      openAboutOffline() {
        this.props.actions?.openAboutModal?.()
      },
    }
  </script>
</account-menu>
